import React, { useState, useCallback } from 'react';
import { Navbar, Nav, NavLink } from "react-bootstrap";
import { library } from '@fortawesome/fontawesome-svg-core';
import { faUser, faPerson, faDragon, faCow, faStopwatch, faGhost, faUnlock, faHome } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './Nav.css';


library.add(faUnlock, faUser, faPerson, faDragon, faCow, faStopwatch, faGhost, faHome);


// import { Router, Routes, Route, Link } from "react-router-dom";
// import { createBrowserHistory } from "history";

// import LoginPage from "./LoginPage";

// const history = createBrowserHistory();



function NavMenu({ isAuthenticated, handleLogin, onNavClick }) {

  const handleClick = useCallback((collectionType) => {
    onNavClick(collectionType);
    setExpanded(false);
  }, [onNavClick]);

  const handleToggle = (isExpanded) => {
    setExpanded(isExpanded);
  };

  const [expanded, setExpanded] = useState(false);

  
  return (
    <div className="d-flex justify-content-center">
      <Navbar 
        expanded={expanded} 
        onToggle={handleToggle} 
        expand="lg" 
        className="w-40"
        style={{
          background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0.7) 100%) !important',
          backdropFilter: 'blur(20px)',
          boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)',
          padding: '15px 0',
          border: 'none'
        }}
      >
        <Navbar.Brand href="/">
          <img className='logo-image'
            src="/images/home.jpg"
            alt="Collectables Logo"
          />
          <span className="navbar-brand-text">Collectables</span>
        </Navbar.Brand>
        <Navbar.Toggle onClick={() => setExpanded(!expanded)} aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto">
            <Nav.Link href="#" onClick={() => handleClick('starwars')} className="nav-first">
              <span className="nav-span"><FontAwesomeIcon icon="person" /></span>
              <span>Star Wars</span>
            </Nav.Link>
            <Nav.Link href="#" onClick={() => handleClick('pokemon')} className="nav-second">
              <span className="nav-span"><FontAwesomeIcon icon="cow" /></span>
              <span>Pokemon</span>
            </Nav.Link>
            <Nav.Link href="#" onClick={() => handleClick('bulbasaur')} className="nav-third">
              <span className="nav-span"><FontAwesomeIcon icon="dragon" /></span>
              <span>Bulbasaur</span>
            </Nav.Link>
            <Nav.Link href="#" onClick={() => handleClick('pocketwatches')} className="nav-fifth">
              <span className="nav-span"><FontAwesomeIcon icon="stopwatch" /></span>
              <span>Pocket Watches</span>
            </Nav.Link>
            <Nav.Link href="#" onClick={() => handleClick('funko')} className="nav-sixth">
              <span className="nav-span"><FontAwesomeIcon icon="ghost" /></span>
              <span>Funko Pops</span>
            </Nav.Link>
            <Nav.Link className="nav-fourth" href="/admin">
              <span className="nav-span"><FontAwesomeIcon icon="unlock" /></span>
              <span>Admin</span>
            </Nav.Link>
            

          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
}

export default NavMenu;